import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormCaption, InformSpan, FormSubmit } from '../../common/components';
import { Input } from '../../common/components/form/input.component';
import { ROUTER_LINKS } from '../../common/consts/app-keys.const';
import { EmailErrors, AUTH_PATTERN } from './validation.pattern';
import { authService } from '../service/auth.service';
import { APP_KEYS } from '../../common/consts';
import { useThrottle } from '../../hooks/useThrottle';

type Inputs = { email: string };

export const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<Inputs>();

  const { mutate: getRecoveryCode, isPending } = useMutation({
    mutationKey: [APP_KEYS.QUERY_KEYS.RECOVERY_CODE],
    mutationFn: (data: Inputs) => authService.forgotPassword(data),
    onSuccess: (email: string) => {
      navigate(ROUTER_LINKS.PASSWORD_RECOVERY, { state: { email } });
    }
  });
  const throttledGetRecoveryCode = useThrottle(getRecoveryCode);

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    throttledGetRecoveryCode(data);
  };

  return (
    <>
      <FormCaption>{t('auth.forgotTitle')}</FormCaption>
      <InformSpan>{t('auth.forgotSubtitle')}</InformSpan>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
        <Input
          errors={errors}
          name="email"
          label={t('auth.email')}
          placeholder={t('auth.enterHere')}
          type="email"
          register={register.bind(null, 'email', {
            required: { message: EmailErrors.required, value: true },
            pattern: {
              value: AUTH_PATTERN.email,
              message: EmailErrors.pattern
            }
          })}
        />
        <FormSubmit
          className="md:mt-[2px] mb-[24px]"
          isLoading={isPending}
          value={t('auth.sendEmail')}
        />
        <Link
          to={ROUTER_LINKS.SIGNIN}
          className="text-center text-base-black font-body text-[16px] font-medium hover:opacity-60"
        >
          {t('auth.backToLogin')}
        </Link>
      </form>
    </>
  );
};
